function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
}
module.exports = _isTransformer;


//////////////////
// WEBPACK FOOTER
// ../~/ramda/src/internal/_isTransformer.js
// module id = 624
// module chunks = 0